import * as Sentry from '@sentry/react';

function getEnvironment() {
	return process.env.REACT_APP_ENV || 'local';
}

let initialized = false;

function canUse() {
	if (getEnvironment() === 'local') {
		return false;
	}

	return Boolean(process.env.REACT_APP_SENTRY_DSN);
}

const SentryMonitor = {
	/**
	 * @param {unknown} error
	 * @returns {void}
	 */
	captureException(error) {
		if (!canUse()) {
			return;
		}

		SentryMonitor.initialize();
		Sentry.captureException(error);
	},

	initialize() {
		if (initialized || !canUse()) {
			return;
		}

		Sentry.init({
			denyUrls: [
				/^chrome:\/\//i,
				/extensions\//i,
				/googletagmanager\.com/i,
				/googleapis\.com/i,
				/xomewidgets\.com/i,
			],
			dsn: process.env.REACT_APP_SENTRY_DSN,
			environment: getEnvironment(),
			integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
			release: `${process.env.REACT_APP_SENTRY_REPO}@${process.env.REACT_APP_VERSION}`,
			tracesSampleRate: Number(
				process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0.2
			),
		});

		initialized = true;
	},
};

export default SentryMonitor;
